import { useEffect, useRef, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import getCompletionData from "../getCompletionData";
import dayjs from "dayjs";
// import { validateSummaryForm } from "../../../../../utils/summaryFormValidation";
import { validateSummaryForm } from "../../../../../../utils/summaryFormValidation";
const useCompletionPortalLogic = (t) => {
  const dispatch = useDispatch();

  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [summaryShow, setSummaryshow] = useState(Digit?.SessionStorage.get("SUMMARY_TAB") || false);
  const [showToast, setShowToast] = useState(null);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const Modal = useModal();

  const tenantId = Digit.ULBService.getStateId();
  const info = Digit.UserService.getUser()?.info;
  const userType = info?.type;
  console.log("INfot got", info, userType);
  const isEmployee = userType === "EMPLOYEE";
  const isCitizen = userType === "CITIZEN";
  const { id } = useParams();
  console.log("useParamsFromColpetion", id, useParams());

  const history = useHistory();
  const location = useLocation();
  let applicationData = location.state?.data;
  let isAppDataLoading = false;
  if (!applicationData) {
    ({ applicationData, isAppDataLoading } = getCompletionData(t, id));
  }
  const isSelfCert = applicationData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const componentRef = useRef();
  const subTabLabels = [
    { label: "General Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    { label: "NOC Status" },
  ];
  const closeToast = () => setShowToast(null);
  const handleDeclarationChange = (event) => setDeclarationChecked(event.target.checked);
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_COMPLETION", applicationData);
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  useEffect(() => {
    if (id && applicationData) {
      console.log("fromuseeffectsettingparams", id, applicationData);

      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, isAppDataLoading]);

  const isCompounding = params?.natureOfConstruction === "Compounding";

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };
  function isValidityExpired(formData) {
    if (!formData?.validityDate) return false;

    // Break into parts: DD/MM/YYYY
    const [day, month, year] = formData.validityDate.split("/").map(Number);

    const validityDate = new Date(year, month - 1, day);
    const oneYearAfter = new Date(validityDate);
    oneYearAfter.setFullYear(oneYearAfter.getFullYear() + 1);

    const today = new Date();

    return today > oneYearAfter;
  }
  const { documents: reduxDocs } = useSelector((state) => state.formMT || {});
  const isFeesRequired = isValidityExpired(params);

  const handleTabChange = async (nextTabNo, formData = null) => {
    if (nextTabNo === 0) {
      handleSubTabChange(0);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", 0);
    }
    if (formData) {
      const data = { ...params, ...formData };
      const isFeesRequired = isValidityExpired(data);
      console.log("formDataOnTabChange", formData, isFeesRequired, nextTabNo);

      if (activeTab === 5) {
        const validation = validateSummaryForm({
          formType: "FORM_COMPLETION",
          formData: data,
          reduxDocuments: reduxDocs,
          declarationChecked,
          t,
        });
        if (!validation.isValid) {
          Modal("Missing Mandatory Fields", validation.errorHtml, "error");
          return;
        }
      }

      try {
        if (activeTab === 5 && params?.status !== "REVERT_TO_APPLICANT") {
          data.workflow = { action: isFeesRequired ? "MAKE_PAYMENT" : "FORWARD_TO_DEPARTMENT", assignes: null };
        } else {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
        }
        // else if (nextTabNo === 4 && params?.status === "REVERT_TO_APPLICANT") {
        //   data.workflow = { action: "FORWARD_TO_DEPARTMENT", assignes: null };
        // }
        updateApiCall.mutate(
          { BPA: data },
          {
            onSuccess: () => {
              onSelect("", data);
              if (activeTab === 5 && params?.status !== "REVERT_TO_APPLICANT") {
                if (isFeesRequired) {
                  history.push(
                    `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
                  );
                  return;
                } else {
                  Modal(
                    "Application Submited",
                    `Your Application ${params?.applicationNo} has been sent to department for further approval`,
                    "success"
                  );
                  if (activeTab === 5) {
                    clearParams();
                  }
                  Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
                  Digit?.SessionStorage.del("EDCR_CREATE");
                  Digit?.SessionStorage.del("FASTPAS_ID");
                  Digit?.SessionStorage.del("SUMMARY_TAB");
                  setTimeout(() => {
                    resetFormMTDocs();
                  }, 0);
                  Digit.SessionStorage.del("MS_CURRENT_TAB");
                  Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
                }
              }
              setShowToast({ error: false, message: `Data has been saved successfully` });
              setActiveTab(nextTabNo);
              Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);

              // if (nextTabNo === 4) {
              //   if (params?.status === "REVERT_TO_APPLICANT") {
              //     Modal(
              //       "Application Submited",
              //       `Your Application ${params?.applicationNo} has been sent to department for further approval`,
              //       "success"
              //     );
              //   }
              //    else {

              //     // if (isSelfCert) {
              //     //   history.push(
              //     //     `/digit-ui/citizen/payment/collect/BPA.MAP_SELF_FEE/${`${formData?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
              //     //   );
              //     // } else if (params?.taxHeadEstimates?.length > 1) {
              //     //   history.push(
              //     //     `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[1]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
              //     //   );
              //     // } else {
              //     //   history.push(
              //     //     `/digit-ui/citizen/payment/collect/${`${params?.taxHeadEstimates?.[0]?.calculationBusinesserviceId}`}/${`${params?.applicationNo}`}/${`${tenantId}`}?tenantId=${`${tenantId}`}`
              //     //   );
              //     // }
              //     clearParams();
              //     Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
              //     Digit?.SessionStorage.del("EDCR_CREATE");
              //     Digit?.SessionStorage.del("FASTPAS_ID");
              //     Digit?.SessionStorage.del("SUMMARY_TAB");
              //     setTimeout(() => {
              //       resetFormMTDocs();
              //     }, 0);
              //     Digit.SessionStorage.del("MS_CURRENT_TAB");
              //     Digit.SessionStorage.del("MS_CURRENT_SUBTAB");
              //   }
              // } else {
              //   if (nextTabNo === 4) {
              //     Digit.SessionStorage.set("SUMMARY_TAB", true);
              //     setSummaryshow(true);
              //   }
              //   setShowToast({ error: false, message: `Data has been saved successfully` });
              //   setActiveTab(nextTabNo);
              //   Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
              // }
            },
            onError: () => {
              Modal("Update Error", "Something went wrong!!", "error");
            },
          }
        );
      } catch (error) {
        console.error(error);
        Modal("Update Error", "Something went wrong!!", "error");
      }
    }
    if (nextTabNo === 5) {
      Digit.SessionStorage.set("SUMMARY_TAB", true);
      setSummaryshow(true);
    }
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData, validityDate: dayjs(formData?.validityDate)?.format("YYYY-MM-DD") };
      // console.log("FormData while create", data, formData, params);
      if (activeTab === 0 && selectedSubTab === 0 && !isSelfCert && !isCompounding && !id) {
        Digit.OBPSService.create({ BPA: data }, tenantId)
          .then((res) => {
            if (res?.BPA?.length > 0) {
              onSelect("", { ...data, ...res.BPA[0] }, true);
              setShowToast({
                error: false,
                message: `Application Created Successfully!`,
              });
              setSelectedSubTab(nextSubTab);
              Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
            }
          })
          .catch((e) => {
            Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
          });
      } else {
        try {
          data.workflow = { action: "UPLOAD_DOC", assignes: null };
          updateApiCall.mutate(
            { BPA: data },
            {
              onSuccess: (res) => {
                onSelect("", res?.BPA?.[0]);
                setShowToast({ error: false, message: `Data has been saved successfully` });
                setSelectedSubTab(nextSubTab);
                Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
              },
              onError: () => {
                Modal("Update Error", "Something went wrong!!", "error");
              },
            }
          );
        } catch (error) {
          console.error(error);
          Modal("Update Error", "Something went wrong!!", "error");
        }
      }
    } else {
      setSelectedSubTab(nextSubTab);
      Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
    }
  };

  return {
    activeTab,
    setActiveTab,
    selectedSubTab,
    setSelectedSubTab,
    summaryShow,
    setSummaryshow,
    showToast,
    setShowToast,
    declarationChecked,
    setDeclarationChecked,
    handleDeclarationChange,
    closeToast,
    params,
    setParams,
    clearParams,
    tenantId,
    isEmployee,
    id,
    applicationData,
    isAppDataLoading,
    isSelfCert,
    componentRef,
    subTabLabels,
    handleTabChange,
    handleSubTabChange,
    onSelect,
    isCompounding,
    initFormMTDocs,
    isFeesRequired,
    isCitizen,
  };
};
export default useCompletionPortalLogic;
